import { render, staticRenderFns } from "./SfTabs.vue?vue&type=template&id=5ab4b852"
import script from "./SfTabs.vue?vue&type=script&lang=js"
export * from "./SfTabs.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfTabs.vue?vue&type=style&index=0&id=5ab4b852&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "3be8f274"
  
)

export default component.exports